export function prepareMsgPhones(text) {
  text = replaceHindiNumber(text);
  text = text.replace(/(?![0-9])\s(?=[0-9])/g, "");
  return text;
}

export function replaceHindiNumber(input) {
  input = input.toString();
  return input.replace(/([٠١٢٣٤٥٦٧٨٩])|([۰۱۲۳۴۵۶۷۸۹])/g, function (m, $1, $2) {
    return m.charCodeAt(0) - ($1 ? 1632 : 1776);
  });
}

export const isObjectType = (value: any): value is object => {
  return typeof value == "object" && !Array.isArray(value) && value != null;
};
export const extractParamId = (qsString, param): number => {
  const params = new URLSearchParams(qsString);
  const cityIdParam = params.get(param);
  return parseInt(cityIdParam);
};

export const awaitDomElement = async (
  selector: string,
  counter = 0
): Promise<HTMLElement> => {
  let elm = document.querySelector(selector) as HTMLElement;
  if (counter > 15) {
    throw new Error(`awaitDomElement "${selector}" not found`);
  }
  if (elm) {
    return elm;
  }
  await new Promise((resolve) => setTimeout(resolve, 200)); //sleep 200
  return awaitDomElement(selector, counter + 1);
};

export const jsonSafeGet = <T>(jsonString, defaultData = {}): T => {
  let output = defaultData as T;
  try {
    output = JSON.parse(jsonString);
  } catch (e) {
    // do nothing.
  }
  return output;
};

export const trimSpacesFromUrl = (url) => {
  url = url?.trim();
  url = url?.replace(/\s+/g, "");
  return url;
};